"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.madeLongDistanceTripsConditional = exports.wantToParticipateInLongDistanceSurveyConditional = exports.wasWorkerBeforeLeaveConditional = exports.parentalOrSickLeaveConditional = exports.personRemoteWorkDaysConditional = exports.onTheRoadUsualWorkplace = exports.householdHasCars = exports.wantToParticipateInOtherSurveysChaireMobiliteConditional = exports.acceptsToBeContactedForHelp = exports.hasWorkingLocationConditional = exports.isStudentConditional = exports.isWorkerConditional = exports.hasDrivingLicenseConditional = exports.ifAge40OrMoreConditional = exports.ifAge16OrLessConditional = exports.ifAge16OrMoreConditional = exports.ifAge15OrMoreConditional = exports.ifAge15OrLessConditional = exports.ifAge14orMoreConditional = exports.ifAge11OrMoreConditional = exports.ifAge6OrMoreConditional = exports.ifAge5orMoreConditional = exports.ifAge5OrLessConditional = exports.ifAge4to15Conditional = exports.ifAge4to13Conditional = exports.ifAge3to5Conditional = exports.hasPreferNotToAnswerToSexAssignedConditional = exports.hasHouseholdBicycleConditional = exports.hasOnePersonWithDisabilityOrHhSize1Conditional = exports.hasHouseholdSize2OrMoreConditional = exports.hasHouseholdSize1Conditional = void 0;
const checkConditionals_1 = require("evolution-common/lib/services/widgets/conditionals/checkConditionals");
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const hasHouseholdSize1Conditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.size',
                comparisonOperator: '===',
                value: 1
            }
        ]
    });
};
exports.hasHouseholdSize1Conditional = hasHouseholdSize1Conditional;
const hasHouseholdSize2OrMoreConditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.size',
                comparisonOperator: '>=',
                value: 2
            }
        ]
    });
};
exports.hasHouseholdSize2OrMoreConditional = hasHouseholdSize2OrMoreConditional;
const hasOnePersonWithDisabilityOrHhSize1Conditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.atLeastOnePersonWithDisability',
                comparisonOperator: '===',
                value: 'yes'
            },
            {
                logicalOperator: '||',
                path: 'household.size',
                comparisonOperator: '===',
                value: 1
            }
        ]
    });
};
exports.hasOnePersonWithDisabilityOrHhSize1Conditional = hasOnePersonWithDisabilityOrHhSize1Conditional;
const hasHouseholdBicycleConditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.bicycleNumber',
                comparisonOperator: '>=',
                value: 1
            }
        ]
    });
};
exports.hasHouseholdBicycleConditional = hasHouseholdBicycleConditional;
const hasPreferNotToAnswerToSexAssignedConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.sexAssignedAtBirth`,
                comparisonOperator: '===',
                value: 'preferNotToAnswer'
            }
        ]
    });
};
exports.hasPreferNotToAnswerToSexAssignedConditional = hasPreferNotToAnswerToSexAssignedConditional;
const ifAge3to5Conditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 3
            },
            {
                logicalOperator: '&&',
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '<=',
                value: 5
            }
        ]
    });
};
exports.ifAge3to5Conditional = ifAge3to5Conditional;
const ifAge4to13Conditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 4
            },
            {
                logicalOperator: '&&',
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '<=',
                value: 13
            }
        ]
    });
};
exports.ifAge4to13Conditional = ifAge4to13Conditional;
const ifAge4to15Conditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 4
            },
            {
                logicalOperator: '&&',
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '<=',
                value: 15
            }
        ]
    });
};
exports.ifAge4to15Conditional = ifAge4to15Conditional;
const ifAge5OrLessConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '<=',
                value: 5
            }
        ]
    });
};
exports.ifAge5OrLessConditional = ifAge5OrLessConditional;
const ifAge5orMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 5
            }
        ]
    });
};
exports.ifAge5orMoreConditional = ifAge5orMoreConditional;
const ifAge6OrMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 6
            }
        ]
    });
};
exports.ifAge6OrMoreConditional = ifAge6OrMoreConditional;
const ifAge11OrMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 11
            }
        ]
    });
};
exports.ifAge11OrMoreConditional = ifAge11OrMoreConditional;
const ifAge14orMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 14
            }
        ]
    });
};
exports.ifAge14orMoreConditional = ifAge14orMoreConditional;
const ifAge15OrLessConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '<=',
                value: 15
            },
            {
                logicalOperator: '&&',
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '!==',
                value: 'null'
            }
        ]
    });
};
exports.ifAge15OrLessConditional = ifAge15OrLessConditional;
const ifAge15OrMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 15
            }
        ]
    });
};
exports.ifAge15OrMoreConditional = ifAge15OrMoreConditional;
const ifAge16OrMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 16
            }
        ]
    });
};
exports.ifAge16OrMoreConditional = ifAge16OrMoreConditional;
const ifAge16OrLessConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '<=',
                value: 16
            },
            {
                logicalOperator: '&&',
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '!==',
                value: 'null'
            }
        ]
    });
};
exports.ifAge16OrLessConditional = ifAge16OrLessConditional;
const ifAge40OrMoreConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.age`,
                comparisonOperator: '>=',
                value: 40
            }
        ]
    });
};
exports.ifAge40OrMoreConditional = ifAge40OrMoreConditional;
const hasDrivingLicenseConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.drivingLicenseOwnership`,
                comparisonOperator: '===',
                value: 'yes'
            }
        ]
    });
};
exports.hasDrivingLicenseConditional = hasDrivingLicenseConditional;
const isWorkerConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'fullTimeWorker'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'partTimeWorker'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'workerAndStudent'
            }
        ]
    });
};
exports.isWorkerConditional = isWorkerConditional;
const isStudentConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'fullTimeStudent'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'partTimeStudent'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'workerAndStudent'
            }
        ]
    });
};
exports.isStudentConditional = isStudentConditional;
const hasWorkingLocationConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.workPlaceType`,
                comparisonOperator: '===',
                value: 'onLocation'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workPlaceType`,
                comparisonOperator: '===',
                value: 'hybrid'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workPlaceType`,
                comparisonOperator: '===',
                value: 'onTheRoadWithUsualPlace'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workPlaceTypeBeforeLeave`,
                comparisonOperator: '===',
                value: 'onLocation'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workPlaceTypeBeforeLeave`,
                comparisonOperator: '===',
                value: 'hybrid'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workPlaceTypeBeforeLeave`,
                comparisonOperator: '===',
                value: 'onTheRoadWithUsualPlace'
            }
        ]
    });
};
exports.hasWorkingLocationConditional = hasWorkingLocationConditional;
const acceptsToBeContactedForHelp = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'acceptToBeContactedForHelp',
                comparisonOperator: '===',
                value: 'yes'
            }
        ]
    });
};
exports.acceptsToBeContactedForHelp = acceptsToBeContactedForHelp;
const wantToParticipateInOtherSurveysChaireMobiliteConditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'end.wouldLikeToParticipateInOtherSurveysChaireMobilite',
                comparisonOperator: '===',
                value: 'yes'
            }
        ]
    });
};
exports.wantToParticipateInOtherSurveysChaireMobiliteConditional = wantToParticipateInOtherSurveysChaireMobiliteConditional;
const householdHasCars = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.carNumber',
                comparisonOperator: '>=',
                value: 1
            }
        ]
    });
};
exports.householdHasCars = householdHasCars;
const onTheRoadUsualWorkplace = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.workPlaceType`,
                comparisonOperator: '===',
                value: 'onTheRoadWithUsualPlace'
            }
        ]
    });
};
exports.onTheRoadUsualWorkplace = onTheRoadUsualWorkplace;
const personRemoteWorkDaysConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.workPlaceType`,
                comparisonOperator: '===',
                value: 'remote'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workPlaceType`,
                comparisonOperator: '===',
                value: 'hybrid'
            }
        ]
    });
};
exports.personRemoteWorkDaysConditional = personRemoteWorkDaysConditional;
const parentalOrSickLeaveConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.occupation`,
                comparisonOperator: '===',
                value: 'parentalOrSickLeave'
            }
        ]
    });
};
exports.parentalOrSickLeaveConditional = parentalOrSickLeaveConditional;
const wasWorkerBeforeLeaveConditional = (interview, path) => {
    const currentPersonId = odSurveyHelpers.getCurrentPersonId({ interview, path }); // Get the current person id
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: `household.persons.${currentPersonId}.workerTypeBeforeLeave`,
                comparisonOperator: '===',
                value: 'fullTime'
            },
            {
                logicalOperator: '||',
                path: `household.persons.${currentPersonId}.workerTypeBeforeLeave`,
                comparisonOperator: '===',
                value: 'partTime'
            }
        ]
    });
};
exports.wasWorkerBeforeLeaveConditional = wasWorkerBeforeLeaveConditional;
const wantToParticipateInLongDistanceSurveyConditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.wouldLikeToParticipateToLongDistanceSurvey',
                comparisonOperator: '===',
                value: 'yes'
            }
        ]
    });
};
exports.wantToParticipateInLongDistanceSurveyConditional = wantToParticipateInLongDistanceSurveyConditional;
const madeLongDistanceTripsConditional = (interview) => {
    return (0, checkConditionals_1.checkConditionals)({
        interview,
        conditionals: [
            {
                path: 'household.madeLongDistanceTripsInLastYear',
                comparisonOperator: '===',
                value: 'yes'
            }
        ]
    });
};
exports.madeLongDistanceTripsConditional = madeLongDistanceTripsConditional;
